<template>
  <b-form inline>
    <b-form-group>
      <b-form-radio-group
        id="input-1"
        v-model="data.precision"
        :options="precisions"
        @change="changePrecision"
        buttons
        button-variant="outline-primary"
        name="radio-btn-outline"
      ></b-form-radio-group>
    </b-form-group>

    <b-form-group class="ml-3">
      <date-picker
        style="width:270px;"
        v-model="data.daterange"
        range
        :type="daterange.type"
        :format="daterange.format"
        :shortcuts="daterange.ranges"
        @close="handleChange"
      ></date-picker>
    </b-form-group>
  </b-form>
</template>

<script>
import {
  startOfToday,
  endOfToday,
  addHours,
  startOfYesterday,
  endOfYesterday,
  addDays,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";
export default {
  name: "DatePickerRange",
  props: {
    dateArray: {
      type: Array,
      default: () => {
        return [startOfYesterday(), endOfToday()];
      }
    },
    precision: {
      type: String,
      default: "HOUR"
    },
    method: {
      required: false,
      type: Function,
      default: () => {
        return Function;
      }
    }
  },
  data() {
    return {
      data: {
        daterange: this.dateArray,
        precision: this.precision,
        dateArray: []
      },

      shortcuts: [
        {
          text: "今天",
          onClick: () => [startOfToday(), endOfToday()]
        },
        {
          text: "昨天",
          onClick: () => [startOfYesterday(), endOfYesterday()]
        },
        {
          text: "本月",
          onClick: () => [startOfMonth(new Date()), endOfMonth(new Date())]
        },
        {
          text: "本年",
          onClick: () => [startOfYear(new Date()), endOfYear(new Date())]
        },
        {
          text: "上一周",
          onClick: () => [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ]
        },
        {
          text: "上一月",
          onClick: () => [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      ],

      daterange: {
        format: "YYYY-MM-DD HH时",
        type: "datetime",

        ranges: []
      },

      precisions: [
        {
          value: "HOUR",
          text: "小时"
        },
        {
          value: "DAY",
          text: "日"
        },
        {
          value: "MONTH",
          text: "月"
        },
        {
          value: "YEAR",
          text: "年"
        }
      ]
    };
  },
  methods: {
    //调用传过来的方法
    query() {
      this.method();
    },
    changePrecision(value) {
      if (value == "DAY") {
        this.daterange.type = "date";
        this.daterange.format = "YYYY-MM-DD";
        this.daterange.ranges = this.shortcuts;
      }
      if (value == "HOUR") {
        this.daterange.type = "datetime";
        this.daterange.format = "YYYY-MM-DD HH时";
        this.daterange.ranges = this.shortcuts;
      }
      if (value == "MONTH") {
        this.daterange.type = "month";
        this.daterange.format = "YYYYMM";
        this.daterange.ranges = [
          {
            text: "本年",
            onClick: () => [startOfYear(new Date()), endOfYear(new Date())]
          }
        ];
      }
      if (value == "YEAR") {
        this.daterange.type = "year";
        this.daterange.format = "YYYY";
        this.daterange.ranges = [
          {
            text: "本年",
            onClick: () => [startOfYear(new Date()), endOfYear(new Date())]
          }
        ];
      }
      this.handleChange();
    },
    handleChange() {
      if (this.data.daterange) {
        this.data.dateArray[0] = addHours(this.data.daterange[0], 8);
        this.data.dateArray[1] = addHours(this.data.daterange[1], 8);
      }
      this.$emit("callback", this.data);
      this.query();
    }
  }
};
</script>

